import { render, staticRenderFns } from "./loaders.vue?vue&type=template&id=306b1d27&scoped=true&"
import script from "./loaders.vue?vue&type=script&lang=js&"
export * from "./loaders.vue?vue&type=script&lang=js&"
import style0 from "./loaders.vue?vue&type=style&index=0&id=306b1d27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b1d27",
  null
  
)

export default component.exports